(function () {
    var aa = new Set("annotation-xml color-profile font-face font-face-src font-face-uri font-face-format font-face-name missing-glyph".split(" "));
    function g(a) { var b = aa.has(a); a = /^[a-z][.0-9_a-z]*-[\-.0-9_a-z]*$/.test(a); return !b && a; }
    function l(a) { var b = a.isConnected; if (void 0 !== b)
        return b; for (; a && !(a.__CE_isImportDocument || a instanceof Document);)
        a = a.parentNode || (window.ShadowRoot && a instanceof ShadowRoot ? a.host : void 0); return !(!a || !(a.__CE_isImportDocument || a instanceof Document)); }
    function n(a, b) { for (; b && b !== a && !b.nextSibling;)
        b = b.parentNode; return b && b !== a ? b.nextSibling : null; }
    function p(a, b, d) { d = void 0 === d ? new Set : d; for (var c = a; c;) {
        if (c.nodeType === Node.ELEMENT_NODE) {
            var e = c;
            b(e);
            var f = e.localName;
            if ("link" === f && "import" === e.getAttribute("rel")) {
                c = e.import;
                if (c instanceof Node && !d.has(c))
                    for (d.add(c), c = c.firstChild; c; c = c.nextSibling)
                        p(c, b, d);
                c = n(a, e);
                continue;
            }
            else if ("template" === f) {
                c = n(a, e);
                continue;
            }
            if (e = e.__CE_shadowRoot)
                for (e = e.firstChild; e; e = e.nextSibling)
                    p(e, b, d);
        }
        c = c.firstChild ? c.firstChild : n(a, c);
    } }
    function r(a, b, d) { a[b] = d; }
    function u() { this.a = new Map; this.g = new Map; this.c = []; this.f = []; this.b = !1; }
    function ba(a, b, d) { a.a.set(b, d); a.g.set(d.constructorFunction, d); }
    function ca(a, b) { a.b = !0; a.c.push(b); }
    function da(a, b) { a.b = !0; a.f.push(b); }
    function v(a, b) { a.b && p(b, function (b) { return w(a, b); }); }
    function w(a, b) { if (a.b && !b.__CE_patched) {
        b.__CE_patched = !0;
        for (var d = 0; d < a.c.length; d++)
            a.c[d](b);
        for (d = 0; d < a.f.length; d++)
            a.f[d](b);
    } }
    function x(a, b) { var d = []; p(b, function (b) { return d.push(b); }); for (b = 0; b < d.length; b++) {
        var c = d[b];
        1 === c.__CE_state ? a.connectedCallback(c) : y(a, c);
    } }
    function z(a, b) { var d = []; p(b, function (b) { return d.push(b); }); for (b = 0; b < d.length; b++) {
        var c = d[b];
        1 === c.__CE_state && a.disconnectedCallback(c);
    } }
    function A(a, b, d) {
        d = void 0 === d ? {} : d;
        var c = d.u || new Set, e = d.i || function (b) { return y(a, b); }, f = [];
        p(b, function (b) { if ("link" === b.localName && "import" === b.getAttribute("rel")) {
            var d = b.import;
            d instanceof Node && (d.__CE_isImportDocument = !0, d.__CE_hasRegistry = !0);
            d && "complete" === d.readyState ? d.__CE_documentLoadHandled = !0 : b.addEventListener("load", function () { var d = b.import; if (!d.__CE_documentLoadHandled) {
                d.__CE_documentLoadHandled = !0;
                var f = new Set(c);
                f.delete(d);
                A(a, d, { u: f, i: e });
            } });
        }
        else
            f.push(b); }, c);
        if (a.b)
            for (b =
                0; b < f.length; b++)
                w(a, f[b]);
        for (b = 0; b < f.length; b++)
            e(f[b]);
    }
    function y(a, b) {
        if (void 0 === b.__CE_state) {
            var d = b.ownerDocument;
            if (d.defaultView || d.__CE_isImportDocument && d.__CE_hasRegistry)
                if (d = a.a.get(b.localName)) {
                    d.constructionStack.push(b);
                    var c = d.constructorFunction;
                    try {
                        try {
                            if (new c !== b)
                                throw Error("The custom element constructor did not produce the element being upgraded.");
                        }
                        finally {
                            d.constructionStack.pop();
                        }
                    }
                    catch (t) {
                        throw b.__CE_state = 2, t;
                    }
                    b.__CE_state = 1;
                    b.__CE_definition = d;
                    if (d.attributeChangedCallback)
                        for (d = d.observedAttributes, c = 0; c < d.length; c++) {
                            var e = d[c], f = b.getAttribute(e);
                            null !== f && a.attributeChangedCallback(b, e, null, f, null);
                        }
                    l(b) && a.connectedCallback(b);
                }
        }
    }
    u.prototype.connectedCallback = function (a) { var b = a.__CE_definition; b.connectedCallback && b.connectedCallback.call(a); };
    u.prototype.disconnectedCallback = function (a) { var b = a.__CE_definition; b.disconnectedCallback && b.disconnectedCallback.call(a); };
    u.prototype.attributeChangedCallback = function (a, b, d, c, e) { var f = a.__CE_definition; f.attributeChangedCallback && -1 < f.observedAttributes.indexOf(b) && f.attributeChangedCallback.call(a, b, d, c, e); };
    function B(a) { var b = document; this.c = a; this.a = b; this.b = void 0; A(this.c, this.a); "loading" === this.a.readyState && (this.b = new MutationObserver(this.f.bind(this)), this.b.observe(this.a, { childList: !0, subtree: !0 })); }
    function C(a) { a.b && a.b.disconnect(); }
    B.prototype.f = function (a) { var b = this.a.readyState; "interactive" !== b && "complete" !== b || C(this); for (b = 0; b < a.length; b++)
        for (var d = a[b].addedNodes, c = 0; c < d.length; c++)
            A(this.c, d[c]); };
    function ea() { var a = this; this.b = this.a = void 0; this.c = new Promise(function (b) { a.b = b; a.a && b(a.a); }); }
    function D(a) { if (a.a)
        throw Error("Already resolved."); a.a = void 0; a.b && a.b(void 0); }
    function E(a) { this.c = !1; this.a = a; this.j = new Map; this.f = function (b) { return b(); }; this.b = !1; this.g = []; this.o = new B(a); }
    E.prototype.l = function (a, b) {
        var d = this;
        if (!(b instanceof Function))
            throw new TypeError("Custom element constructors must be functions.");
        if (!g(a))
            throw new SyntaxError("The element name '" + a + "' is not valid.");
        if (this.a.a.get(a))
            throw Error("A custom element with name '" + a + "' has already been defined.");
        if (this.c)
            throw Error("A custom element is already being defined.");
        this.c = !0;
        try {
            var c = function (b) {
                var a = e[b];
                if (void 0 !== a && !(a instanceof Function))
                    throw Error("The '" + b + "' callback must be a function.");
                return a;
            }, e = b.prototype;
            if (!(e instanceof Object))
                throw new TypeError("The custom element constructor's prototype is not an object.");
            var f = c("connectedCallback");
            var t = c("disconnectedCallback");
            var k = c("adoptedCallback");
            var h = c("attributeChangedCallback");
            var m = b.observedAttributes || [];
        }
        catch (q) {
            return;
        }
        finally {
            this.c = !1;
        }
        b = { localName: a, constructorFunction: b, connectedCallback: f, disconnectedCallback: t, adoptedCallback: k, attributeChangedCallback: h, observedAttributes: m, constructionStack: [] };
        ba(this.a, a, b);
        this.g.push(b);
        this.b || (this.b = !0, this.f(function () { return fa(d); }));
    };
    E.prototype.i = function (a) { A(this.a, a); };
    function fa(a) { if (!1 !== a.b) {
        a.b = !1;
        for (var b = a.g, d = [], c = new Map, e = 0; e < b.length; e++)
            c.set(b[e].localName, []);
        A(a.a, document, { i: function (b) { if (void 0 === b.__CE_state) {
                var e = b.localName, f = c.get(e);
                f ? f.push(b) : a.a.a.get(e) && d.push(b);
            } } });
        for (e = 0; e < d.length; e++)
            y(a.a, d[e]);
        for (; 0 < b.length;) {
            var f = b.shift();
            e = f.localName;
            f = c.get(f.localName);
            for (var t = 0; t < f.length; t++)
                y(a.a, f[t]);
            (e = a.j.get(e)) && D(e);
        }
    } }
    E.prototype.get = function (a) { if (a = this.a.a.get(a))
        return a.constructorFunction; };
    E.prototype.m = function (a) { if (!g(a))
        return Promise.reject(new SyntaxError("'" + a + "' is not a valid custom element name.")); var b = this.j.get(a); if (b)
        return b.c; b = new ea; this.j.set(a, b); this.a.a.get(a) && !this.g.some(function (b) { return b.localName === a; }) && D(b); return b.c; };
    E.prototype.s = function (a) { C(this.o); var b = this.f; this.f = function (d) { return a(function () { return b(d); }); }; };
    window.CustomElementRegistry = E;
    E.prototype.define = E.prototype.l;
    E.prototype.upgrade = E.prototype.i;
    E.prototype.get = E.prototype.get;
    E.prototype.whenDefined = E.prototype.m;
    E.prototype.polyfillWrapFlushCallback = E.prototype.s;
    var F = window.Document.prototype.createElement, G = window.Document.prototype.createElementNS, ha = window.Document.prototype.importNode, ia = window.Document.prototype.prepend, ja = window.Document.prototype.append, ka = window.DocumentFragment.prototype.prepend, la = window.DocumentFragment.prototype.append, H = window.Node.prototype.cloneNode, I = window.Node.prototype.appendChild, J = window.Node.prototype.insertBefore, K = window.Node.prototype.removeChild, L = window.Node.prototype.replaceChild, M = Object.getOwnPropertyDescriptor(window.Node.prototype, "textContent"), N = window.Element.prototype.attachShadow, O = Object.getOwnPropertyDescriptor(window.Element.prototype, "innerHTML"), P = window.Element.prototype.getAttribute, Q = window.Element.prototype.setAttribute, R = window.Element.prototype.removeAttribute, S = window.Element.prototype.getAttributeNS, T = window.Element.prototype.setAttributeNS, U = window.Element.prototype.removeAttributeNS, ma = window.Element.prototype.insertAdjacentElement, na = window.Element.prototype.insertAdjacentHTML, oa = window.Element.prototype.prepend, pa = window.Element.prototype.append, V = window.Element.prototype.before, qa = window.Element.prototype.after, ra = window.Element.prototype.replaceWith, sa = window.Element.prototype.remove, ta = window.HTMLElement, W = Object.getOwnPropertyDescriptor(window.HTMLElement.prototype, "innerHTML"), ua = window.HTMLElement.prototype.insertAdjacentElement, va = window.HTMLElement.prototype.insertAdjacentHTML;
    var wa = new function () { };
    function xa() {
        var a = X;
        window.HTMLElement = function () {
            function b() {
                var b = this.constructor, c = a.g.get(b);
                if (!c)
                    throw Error("The custom element being constructed was not registered with `customElements`.");
                var e = c.constructionStack;
                if (0 === e.length)
                    return e = F.call(document, c.localName), Object.setPrototypeOf(e, b.prototype), e.__CE_state = 1, e.__CE_definition = c, w(a, e), e;
                c = e.length - 1;
                var f = e[c];
                if (f === wa)
                    throw Error("The HTMLElement constructor was either called reentrantly for this constructor or called multiple times.");
                e[c] = wa;
                Object.setPrototypeOf(f, b.prototype);
                w(a, f);
                return f;
            }
            b.prototype = ta.prototype;
            Object.defineProperty(b.prototype, "constructor", { writable: !0, configurable: !0, enumerable: !1, value: b });
            return b;
        }();
    }
    function Y(a, b, d) { function c(b) { return function (d) { for (var e = [], c = 0; c < arguments.length; ++c)
        e[c] = arguments[c]; c = []; for (var f = [], m = 0; m < e.length; m++) {
        var q = e[m];
        q instanceof Element && l(q) && f.push(q);
        if (q instanceof DocumentFragment)
            for (q = q.firstChild; q; q = q.nextSibling)
                c.push(q);
        else
            c.push(q);
    } b.apply(this, e); for (e = 0; e < f.length; e++)
        z(a, f[e]); if (l(this))
        for (e = 0; e < c.length; e++)
            f = c[e], f instanceof Element && x(a, f); }; } void 0 !== d.h && (b.prepend = c(d.h)); void 0 !== d.append && (b.append = c(d.append)); }
    function ya() {
        var a = X;
        r(Document.prototype, "createElement", function (b) { if (this.__CE_hasRegistry) {
            var d = a.a.get(b);
            if (d)
                return new d.constructorFunction;
        } b = F.call(this, b); w(a, b); return b; });
        r(Document.prototype, "importNode", function (b, d) { b = ha.call(this, b, !!d); this.__CE_hasRegistry ? A(a, b) : v(a, b); return b; });
        r(Document.prototype, "createElementNS", function (b, d) {
            if (this.__CE_hasRegistry && (null === b || "http://www.w3.org/1999/xhtml" === b)) {
                var c = a.a.get(d);
                if (c)
                    return new c.constructorFunction;
            }
            b = G.call(this, b, d);
            w(a, b);
            return b;
        });
        Y(a, Document.prototype, { h: ia, append: ja });
    }
    function za() {
        function a(a, c) { Object.defineProperty(a, "textContent", { enumerable: c.enumerable, configurable: !0, get: c.get, set: function (a) { if (this.nodeType === Node.TEXT_NODE)
                c.set.call(this, a);
            else {
                var d = void 0;
                if (this.firstChild) {
                    var e = this.childNodes, k = e.length;
                    if (0 < k && l(this)) {
                        d = Array(k);
                        for (var h = 0; h < k; h++)
                            d[h] = e[h];
                    }
                }
                c.set.call(this, a);
                if (d)
                    for (a = 0; a < d.length; a++)
                        z(b, d[a]);
            } } }); }
        var b = X;
        r(Node.prototype, "insertBefore", function (a, c) {
            if (a instanceof DocumentFragment) {
                var e = Array.prototype.slice.apply(a.childNodes);
                a = J.call(this, a, c);
                if (l(this))
                    for (c = 0; c < e.length; c++)
                        x(b, e[c]);
                return a;
            }
            e = l(a);
            c = J.call(this, a, c);
            e && z(b, a);
            l(this) && x(b, a);
            return c;
        });
        r(Node.prototype, "appendChild", function (a) { if (a instanceof DocumentFragment) {
            var c = Array.prototype.slice.apply(a.childNodes);
            a = I.call(this, a);
            if (l(this))
                for (var e = 0; e < c.length; e++)
                    x(b, c[e]);
            return a;
        } c = l(a); e = I.call(this, a); c && z(b, a); l(this) && x(b, a); return e; });
        r(Node.prototype, "cloneNode", function (a) {
            a = H.call(this, !!a);
            this.ownerDocument.__CE_hasRegistry ? A(b, a) : v(b, a);
            return a;
        });
        r(Node.prototype, "removeChild", function (a) { var c = l(a), e = K.call(this, a); c && z(b, a); return e; });
        r(Node.prototype, "replaceChild", function (a, c) { if (a instanceof DocumentFragment) {
            var e = Array.prototype.slice.apply(a.childNodes);
            a = L.call(this, a, c);
            if (l(this))
                for (z(b, c), c = 0; c < e.length; c++)
                    x(b, e[c]);
            return a;
        } e = l(a); var f = L.call(this, a, c), d = l(this); d && z(b, c); e && z(b, a); d && x(b, a); return f; });
        M && M.get ? a(Node.prototype, M) : ca(b, function (b) {
            a(b, { enumerable: !0, configurable: !0, get: function () {
                    for (var a = [], b = 0; b < this.childNodes.length; b++) {
                        var f = this.childNodes[b];
                        f.nodeType !== Node.COMMENT_NODE && a.push(f.textContent);
                    }
                    return a.join("");
                }, set: function (a) { for (; this.firstChild;)
                    K.call(this, this.firstChild); null != a && "" !== a && I.call(this, document.createTextNode(a)); } });
        });
    }
    function Aa(a) {
        function b(b) { return function (e) { for (var c = [], d = 0; d < arguments.length; ++d)
            c[d] = arguments[d]; d = []; for (var k = [], h = 0; h < c.length; h++) {
            var m = c[h];
            m instanceof Element && l(m) && k.push(m);
            if (m instanceof DocumentFragment)
                for (m = m.firstChild; m; m = m.nextSibling)
                    d.push(m);
            else
                d.push(m);
        } b.apply(this, c); for (c = 0; c < k.length; c++)
            z(a, k[c]); if (l(this))
            for (c = 0; c < d.length; c++)
                k = d[c], k instanceof Element && x(a, k); }; }
        var d = Element.prototype;
        void 0 !== V && (d.before = b(V));
        void 0 !== V && (d.after = b(qa));
        void 0 !== ra &&
            r(d, "replaceWith", function (b) { for (var e = [], c = 0; c < arguments.length; ++c)
                e[c] = arguments[c]; c = []; for (var d = [], k = 0; k < e.length; k++) {
                var h = e[k];
                h instanceof Element && l(h) && d.push(h);
                if (h instanceof DocumentFragment)
                    for (h = h.firstChild; h; h = h.nextSibling)
                        c.push(h);
                else
                    c.push(h);
            } k = l(this); ra.apply(this, e); for (e = 0; e < d.length; e++)
                z(a, d[e]); if (k)
                for (z(a, this), e = 0; e < c.length; e++)
                    d = c[e], d instanceof Element && x(a, d); });
        void 0 !== sa && r(d, "remove", function () { var b = l(this); sa.call(this); b && z(a, this); });
    }
    function Ba() {
        function a(a, b) { Object.defineProperty(a, "innerHTML", { enumerable: b.enumerable, configurable: !0, get: b.get, set: function (a) { var e = this, d = void 0; l(this) && (d = [], p(this, function (a) { a !== e && d.push(a); })); b.set.call(this, a); if (d)
                for (var f = 0; f < d.length; f++) {
                    var t = d[f];
                    1 === t.__CE_state && c.disconnectedCallback(t);
                } this.ownerDocument.__CE_hasRegistry ? A(c, this) : v(c, this); return a; } }); }
        function b(a, b) { r(a, "insertAdjacentElement", function (a, e) { var d = l(e); a = b.call(this, a, e); d && z(c, e); l(a) && x(c, e); return a; }); }
        function d(a, b) {
            function e(a, b) { for (var e = []; a !== b; a = a.nextSibling)
                e.push(a); for (b = 0; b < e.length; b++)
                A(c, e[b]); }
            r(a, "insertAdjacentHTML", function (a, c) {
                a = a.toLowerCase();
                if ("beforebegin" === a) {
                    var d = this.previousSibling;
                    b.call(this, a, c);
                    e(d || this.parentNode.firstChild, this);
                }
                else if ("afterbegin" === a)
                    d = this.firstChild, b.call(this, a, c), e(this.firstChild, d);
                else if ("beforeend" === a)
                    d = this.lastChild, b.call(this, a, c), e(d || this.firstChild, null);
                else if ("afterend" === a)
                    d = this.nextSibling, b.call(this, a, c), e(this.nextSibling, d);
                else
                    throw new SyntaxError("The value provided (" + String(a) + ") is not one of 'beforebegin', 'afterbegin', 'beforeend', or 'afterend'.");
            });
        }
        var c = X;
        N && r(Element.prototype, "attachShadow", function (a) { a = N.call(this, a); var b = c; if (b.b && !a.__CE_patched) {
            a.__CE_patched = !0;
            for (var e = 0; e < b.c.length; e++)
                b.c[e](a);
        } return this.__CE_shadowRoot = a; });
        O && O.get ? a(Element.prototype, O) : W && W.get ? a(HTMLElement.prototype, W) : da(c, function (b) {
            a(b, { enumerable: !0, configurable: !0, get: function () { return H.call(this, !0).innerHTML; },
                set: function (a) { var b = "template" === this.localName, c = b ? this.content : this, e = G.call(document, this.namespaceURI, this.localName); for (e.innerHTML = a; 0 < c.childNodes.length;)
                    K.call(c, c.childNodes[0]); for (a = b ? e.content : e; 0 < a.childNodes.length;)
                    I.call(c, a.childNodes[0]); } });
        });
        r(Element.prototype, "setAttribute", function (a, b) { if (1 !== this.__CE_state)
            return Q.call(this, a, b); var e = P.call(this, a); Q.call(this, a, b); b = P.call(this, a); c.attributeChangedCallback(this, a, e, b, null); });
        r(Element.prototype, "setAttributeNS", function (a, b, d) { if (1 !== this.__CE_state)
            return T.call(this, a, b, d); var e = S.call(this, a, b); T.call(this, a, b, d); d = S.call(this, a, b); c.attributeChangedCallback(this, b, e, d, a); });
        r(Element.prototype, "removeAttribute", function (a) { if (1 !== this.__CE_state)
            return R.call(this, a); var b = P.call(this, a); R.call(this, a); null !== b && c.attributeChangedCallback(this, a, b, null, null); });
        r(Element.prototype, "removeAttributeNS", function (a, b) {
            if (1 !== this.__CE_state)
                return U.call(this, a, b);
            var d = S.call(this, a, b);
            U.call(this, a, b);
            var e = S.call(this, a, b);
            d !== e && c.attributeChangedCallback(this, b, d, e, a);
        });
        ua ? b(HTMLElement.prototype, ua) : ma ? b(Element.prototype, ma) : console.warn("Custom Elements: `Element#insertAdjacentElement` was not patched.");
        va ? d(HTMLElement.prototype, va) : na ? d(Element.prototype, na) : console.warn("Custom Elements: `Element#insertAdjacentHTML` was not patched.");
        Y(c, Element.prototype, { h: oa, append: pa });
        Aa(c);
    }
    var Z = window.customElements;
    if (!Z || Z.forcePolyfill || "function" != typeof Z.define || "function" != typeof Z.get) {
        var X = new u;
        xa();
        ya();
        Y(X, DocumentFragment.prototype, { h: ka, append: la });
        za();
        Ba();
        document.__CE_hasRegistry = !0;
        var customElements = new E(X);
        Object.defineProperty(window, "customElements", { configurable: !0, enumerable: !0, value: customElements });
    }
}).call(self);
// Polyfill document.baseURI
if (typeof document.baseURI !== 'string') {
    Object.defineProperty(Document.prototype, 'baseURI', {
        enumerable: true,
        configurable: true,
        get: function () {
            var base = document.querySelector('base');
            if (base) {
                return base.href;
            }
            return document.URL;
        }
    });
}
// Polyfill CustomEvent
if (typeof window.CustomEvent !== 'function') {
    window.CustomEvent = function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    };
    window.CustomEvent.prototype = window.Event.prototype;
}
// Event.composedPath
(function (E, d, w) {
    if (!E.composedPath) {
        E.composedPath = function () {
            if (this.path) {
                return this.path;
            }
            var target = this.target;
            this.path = [];
            while (target.parentNode !== null) {
                this.path.push(target);
                target = target.parentNode;
            }
            this.path.push(d, w);
            return this.path;
        };
    }
})(Event.prototype, document, window);
/*!
Element.closest and Element.matches
https://github.com/jonathantneal/closest
Creative Commons Zero v1.0 Universal
*/
(function (a) { "function" !== typeof a.matches && (a.matches = a.msMatchesSelector || a.mozMatchesSelector || a.webkitMatchesSelector || function (a) { a = (this.document || this.ownerDocument).querySelectorAll(a); for (var b = 0; a[b] && a[b] !== this;)
    ++b; return !!a[b]; }); "function" !== typeof a.closest && (a.closest = function (a) { for (var b = this; b && 1 === b.nodeType;) {
    if (b.matches(a))
        return b;
    b = b.parentNode;
} return null; }); })(window.Element.prototype);
/*!
Element.getRootNode()
*/
(function (c) { function d(a) { a = b(a); return 11 === a.nodeType ? d(a.host) : a; } function b(a) { return a.parentNode ? b(a.parentNode) : a; } "function" !== typeof c.getRootNode && (c.getRootNode = function (a) { return a && a.composed ? d(this) : b(this); }); })(Element.prototype);
/*!
Element.remove()
*/
(function (b) { b.forEach(function (a) { a.hasOwnProperty("remove") || Object.defineProperty(a, "remove", { configurable: !0, enumerable: !0, writable: !0, value: function () { null !== this.parentNode && this.parentNode.removeChild(this); } }); }); })([Element.prototype, CharacterData.prototype, DocumentType.prototype]);
/*!
Element.classList
*/
!function (e) { 'classList' in e || Object.defineProperty(e, "classList", { get: function () { var e = this, t = (e.getAttribute("class") || "").replace(/^\s+|\s$/g, "").split(/\s+/g); function n() { t.length > 0 ? e.setAttribute("class", t.join(" ")) : e.removeAttribute("class"); } return "" === t[0] && t.splice(0, 1), t.toggle = function (e, i) { void 0 !== i ? i ? t.add(e) : t.remove(e) : -1 !== t.indexOf(e) ? t.splice(t.indexOf(e), 1) : t.push(e), n(); }, t.add = function () { for (var e = [].slice.call(arguments), i = 0, s = e.length; i < s; i++)
        -1 === t.indexOf(e[i]) && t.push(e[i]); n(); }, t.remove = function () { for (var e = [].slice.call(arguments), i = 0, s = e.length; i < s; i++)
        -1 !== t.indexOf(e[i]) && t.splice(t.indexOf(e[i]), 1); n(); }, t.item = function (e) { return t[e]; }, t.contains = function (e) { return -1 !== t.indexOf(e); }, t.replace = function (e, i) { -1 !== t.indexOf(e) && t.splice(t.indexOf(e), 1, i), n(); }, t.value = e.getAttribute("class") || "", t; } }); }(Element.prototype);
